jQuery(document).ready(function () {
    jQuery('.owl-carousel.mb-jj-article-images').owlCarousel({
        loop: true,
        margin: 10,
        nav: true,
        items: 1,
        autoplay: false,
        autoHeight: true,
        navText: ["<i class=\"far fa-arrow-left\"></i>", "<i class=\"far fa-arrow-right\"></i>"],
    });

    jQuery('.owl-carousel.article-carousel--narrow').owlCarousel({
        loop: true,
        margin: 10,
        nav: true,
        items: 2,
        autoplay: false,
        lazyLoad: false,
        autoHeight: false,
        itemElement: 'article',
        dots: false,
        center: true,
        navText: ["<i class=\"far fa-arrow-left\"></i>", "<i class=\"far fa-arrow-right\"></i>"],
        responsive: {
            0: {
                items: 1,
                nav: true
            },
            768: {
                items: 2,
            },
            1024: {
                items: 2,
            }
        }
    });

    jQuery('.owl-carousel.article-carousel--full').owlCarousel({
        loop: true,
        margin: 10,
        nav: true,
        items: 2,
        autoplay: false,
        lazyLoad: false,
        autoHeight: false,
        itemElement: 'article',
        dots: false,
        center: true,
        navText: ["<i class=\"far fa-arrow-left\"></i>", "<i class=\"far fa-arrow-right\"></i>"],
        responsive: {
            0: {
                items: 1,
                nav: true
            },
            768: {
                items: 3,
            },
            1024: {
                items: 3,
            }
        }
    });

    jQuery('.owl-carousel.mb-jj-articlecarousel-sidebar').owlCarousel({
        loop: true,
        margin: 10,
        nav: true,
        items: 1,
        autoplay: false,
        lazyLoad: false,
        autoHeight: false,
        itemElement: 'article',
        dots: false,
        center: true,
        navText: ["<i class=\"far fa-arrow-left\"></i>", "<i class=\"far fa-arrow-right\"></i>"],
    });
});